/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAdminUserPointsDetailPageListRespVo
 */
export interface GetAdminUserPointsDetailPageListRespVo {
    /**
     * 记录数据编号
     * @type {number}
     * @memberof GetAdminUserPointsDetailPageListRespVo
     */
    id?: number;
    /**
     * 用户 ID
     * @type {number}
     * @memberof GetAdminUserPointsDetailPageListRespVo
     */
    userId?: number;
    /**
     * 会员名
     * @type {string}
     * @memberof GetAdminUserPointsDetailPageListRespVo
     */
    userName?: string;
    /**
     * 会员编号
     * @type {string}
     * @memberof GetAdminUserPointsDetailPageListRespVo
     */
    userCode?: string;
    /**
     * 使用区分编号
     * @type {number}
     * @memberof GetAdminUserPointsDetailPageListRespVo
     */
    changeReason?: number;
    /**
     * 使用区分名称
     * @type {string}
     * @memberof GetAdminUserPointsDetailPageListRespVo
     */
    changeReasonDesc?: string;
    /**
     * 内容
     * @type {string}
     * @memberof GetAdminUserPointsDetailPageListRespVo
     */
    remark?: string;
    /**
     * 积分值(出入积分)
     * @type {number}
     * @memberof GetAdminUserPointsDetailPageListRespVo
     */
    amount?: number;
    /**
     * 可用积分
     * @type {number}
     * @memberof GetAdminUserPointsDetailPageListRespVo
     */
    principal?: number;
    /**
     * 积分出入类型  0 出积分，1 入积分
     * @type {number}
     * @memberof GetAdminUserPointsDetailPageListRespVo
     */
    intOutType?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof GetAdminUserPointsDetailPageListRespVo
     */
    createTime?: string;
}

/**
 * Check if a given object implements the GetAdminUserPointsDetailPageListRespVo interface.
 */
export function instanceOfGetAdminUserPointsDetailPageListRespVo(value: object): value is GetAdminUserPointsDetailPageListRespVo {
    return true;
}

export function GetAdminUserPointsDetailPageListRespVoFromJSON(json: any): GetAdminUserPointsDetailPageListRespVo {
    return GetAdminUserPointsDetailPageListRespVoFromJSONTyped(json, false);
}

export function GetAdminUserPointsDetailPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAdminUserPointsDetailPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'changeReason': json['changeReason'] == null ? undefined : json['changeReason'],
        'changeReasonDesc': json['changeReasonDesc'] == null ? undefined : json['changeReasonDesc'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'principal': json['principal'] == null ? undefined : json['principal'],
        'intOutType': json['intOutType'] == null ? undefined : json['intOutType'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
    };
}

export function GetAdminUserPointsDetailPageListRespVoToJSON(json: any): GetAdminUserPointsDetailPageListRespVo {
    return GetAdminUserPointsDetailPageListRespVoToJSONTyped(json, false);
}

export function GetAdminUserPointsDetailPageListRespVoToJSONTyped(value?: GetAdminUserPointsDetailPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'changeReason': value['changeReason'],
        'changeReasonDesc': value['changeReasonDesc'],
        'remark': value['remark'],
        'amount': value['amount'],
        'principal': value['principal'],
        'intOutType': value['intOutType'],
        'createTime': value['createTime'],
    };
}

